import { Button, Collapse, Form, Menu } from 'antd';
import DefaultContext from 'flexbiz-core/components/auth/Context';
import React, { useContext, useEffect, useState } from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import { useForm } from 'react-hook-form';
import { toast } from 'react-hot-toast';
import { HiChevronDown } from 'react-icons/hi2';
import { useCore } from '../../../../../hooks';
import VModal from '../../../VComponent/VModal';
import TabInfomation from './TabItemsVoucher/Default/TabInfomation';
import TabTotal from './TabItemsVoucher/Default/TabTotal';
import TabCpmh from './TabItemsVoucher/TabCpmh';
import TabDetail from './TabItemsVoucher/TabDetail';
import TabVat from './TabItemsVoucher/TabVat';

const defaultValues = { status: true };
function CopyVoucherDialog({ open, handleClose, data, title, api }) {
	const [checkedFolow, setCheckedFolow] = useState(false);
	const [checkedEdit, setCheckedEdit] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [isDataVoucherDetail, setIsDataVoucherDetail] = useState();
	const [isDataVoucherVat, setIsDataVoucherVat] = useState();
	const [isDataVoucherCtcpmhs, setIsDataVoucherCtcpmhs] = useState();
	const [isFieldNt, setIsFieldNt] = useState({
		ma_nt: data[0]?.ma_nt,
		ty_gia: data[0]?.ty_gia,
	});
	const [isDataDefaultTab, setIsDataDefaultTab] = useState({});
	const [isTotalVoucher, setIsTotalVoucher] = useState({
		t_sl: data[0]?.t_sl,
		t_tien_hang: data[0]?.t_tien_hang,
		t_ck: data[0]?.t_ck,
		t_cp_cpb: data[0]?.t_cp_cpb,
		t_thue_vao: data[0]?.t_thue_vao,
	});
	const [isAllotmentPn1, setIsAllotmentPn1] = useState();
	const context = useContext(DefaultContext);
	const core = useCore();

	const hookForm = useForm({
		defaultValues,
	});

	const {
		getValues,
		setValue,
		register,
		formState: { errors },
		control,
		handleSubmit,
		reset,
		// formState: { isSubmitting },
	} = hookForm;

	const handleChangeFolow = (event) => {
		setCheckedFolow(event.target.checked);
	};

	const handleChangeEdit = (event) => {
		setCheckedEdit(event.target.checked);
	};

	useEffect(() => {
		reset({
			...defaultValues,
			...data[data.length - 1],
		});
	}, [data, reset]);

	const onSubmit = async (data) => {
		const isDataVoucherDetailNew = isDataVoucherDetail.filter((item) => item.ma_vt !== '');
		const isDataVoucherVatNew = isDataVoucherVat.filter((item) => item.so_hd !== '');
		isDataVoucherVatNew &&
			isDataVoucherVatNew.forEach((item) => {
				item.line = '';
				!item.ngay_hd && (item.ngay_hd = new Date());
			});
		const isDataVoucherCtcpmhsNew = isDataVoucherCtcpmhs.filter((item) => item.ma_cp !== '');
		// xoá _id để không bị trùng lặp
		delete data._id;
		delete data.user_created;
		delete data.user_updated;
		setIsLoading(true);
		try {
			await context.apis.asyncPostList(context.userInfo.token, api, {
				...data,
				details: isDataVoucherDetailNew,
				vatvaos: isDataVoucherVatNew,
				ctcpmhs: isDataVoucherCtcpmhsNew,
			});
			toast.success('Tạo thành công');
			// eslint-disable-next-line no-useless-catch
		} catch (error) {
			throw error;
		} finally {
			setIsLoading(false);
		}
	};

	const onSave = (data) =>
		onSubmit(data)
			.then(() => {
				handleClose();
			})
			.catch((error) => {
				core.contextAlert(error);
			});

	const onSaveAndCopy = (data) =>
		onSubmit(data)
			.then(() => {
				delete data._id;
				data.so_ct = '';
				data.ngay_ct = new Date();

				reset(data);
			})
			.catch((error) => {
				core.contextAlert(error);
			});

	const handleGetDataDetail = (data) => {
		setIsTotalVoucher({
			...isTotalVoucher,
			t_sl: data?.reduce((a, b) => a + b.sl_nhap, 0),
			t_tien_hang: data?.reduce((a, b) => a + b.tien_hang, 0),
			t_ck: data?.reduce((a, b) => a + b.tien_ck, 0),
		});
		setIsDataVoucherDetail(data);
	};
	const handleGetDataVat = (data) => {
		setIsTotalVoucher({
			...isTotalVoucher,
			t_thue_vao: data?.reduce((a, b) => a + b.t_thue, 0),
		});
		setIsDataVoucherVat(data);
	};
	const handleGetDataCtcpmhs = (data) => {
		setIsTotalVoucher({
			...isTotalVoucher,
			t_cp_cpb: data?.reduce((a, b) => a + b.tien_cp, 0),
		});
		setIsDataVoucherCtcpmhs(data);
	};

	const handleDefaultTab = (data) => {
		setIsDataDefaultTab({
			...isDataDefaultTab,
			tk_co: data.tk_co,
		});
	};

	const handleAllotmentPn1 = (data) => {
		setIsAllotmentPn1(data);
	};

	const getAllotmentPn1 = () => {
		return isAllotmentPn1;
	};

	const scrollTo = (id) => {
		const el = document.getElementById(id);
		el.scrollIntoView({
			behavior: 'smooth',
			block: 'center',
		});
	};

	const formSections = [
		{
			id: 'information',
			title: 'Thông tin',
			content: (
				<TabInfomation
					getValues={getValues}
					register={register}
					setValue={setValue}
					errors={errors}
					control={control}
					setIsFieldNt={setIsFieldNt}
					handleDefaultTab={handleDefaultTab}
				/>
			),
		},
		{
			id: 'detail',
			title: 'Chi tiết',
			content: (
				<TabDetail
					data={data[0]}
					readonly={false}
					handleGetDataDetail={handleGetDataDetail}
					getAllotmentPn1={getAllotmentPn1}
					view={false} // hidden toolbar
					selectRow={true}
					isFieldNt={isFieldNt}
					setValue={setValue}
				/>
			),
		},
		{
			id: 'ctcpmhs',
			title: 'Chi phí mua hàng',
			content: (
				<TabCpmh
					data={data[0]}
					readonly={false}
					handleGetDataCtcpmhs={handleGetDataCtcpmhs}
					handleAllotmentPn1={handleAllotmentPn1}
					view={false} // hidden toolbar
					selectRow={true}
					isFieldNt={isFieldNt}
					setValue={setValue}
				/>
			),
		},
		{
			id: 'vatvaos',
			title: 'Thuế vào',
			content: (
				<TabVat
					data={data[0]}
					readonly={false}
					handleGetDataVat={handleGetDataVat}
					view={false} // hidden toolbar
					selectRow={true}
					setValue={setValue}
					isFieldNt={isFieldNt}
					isTotalVoucher={isTotalVoucher}
				/>
			),
		},
		{
			id: 'voucher',
			title: 'Tổng',
			content: (
				<TabTotal
					handleChangeFolow={handleChangeFolow}
					handleChangeEdit={handleChangeEdit}
					checkedFolow={checkedFolow}
					checkedEdit={checkedEdit}
					isTotalVoucher={isTotalVoucher}
				/>
			),
		},
	];

	return (
		<VModal
			open={open}
			onClose={handleClose}
			destroyOnClose
			confirmLoading
			title={`${title} - tạo chứng từ mới`}
			width="98vw"
			height="98vh"
			footer={[
				<Button
					key="submit"
					type="primary"
					form="lead-form-full"
					htmlType="submit"
					onClick={handleSubmit(onSave)}
					id="btnSave"
				>
					Lưu
				</Button>,
				// <Button
				// 	key="submit"
				// 	type="primary"
				// 	form="lead-form-full"
				// 	htmlType="submit"
				// 	onClick={handleSubmit(onSaveAndCopy)}
				// 	id="btnSave"
				// >
				// 	Lưu & sao chép
				// </Button>,
				<Button key="reset" type="dashed" danger onClick={handleClose}>
					Bỏ qua
				</Button>,
			]}
			centered
		>
			<div className="mdf_container">
				<Menu
					defaultSelectedKeys={[formSections[0].id]}
					mode="vertical"
					style={{ width: 200 }}
					items={formSections.map(({ id, title }) => ({
						key: id,
						label: title,
					}))}
					onClick={({ key }) => scrollTo(key)}
				/>

				<Form
					id="lead-form-full"
					// form={form}
					// onFinish={handleSubmit}
					// onError={handleError}
					onKeyDown={(e) => e.key === 'Enter' && e.preventDefault()} // prevent submit on enter
					className="mdf_content"
					labelWrap
				>
					{formSections.map(({ id, title, content }) => (
						<Collapse
							key={id}
							defaultActiveKey={['1']}
							size="small"
							expandIcon={({ isActive }) => (
								<HiChevronDown
									style={{
										transition: 'all 0.3s ease-in-out',
										transform: `rotate(${isActive ? 0 : -90}deg)`,
									}}
								/>
							)}
						>
							<Collapse.Panel header={title} key="1" id={id}>
								{content}
							</Collapse.Panel>
						</Collapse>
					))}

					{/* Placeholder */}
					<div style={{ minHeight: '20%' }} />
				</Form>
			</div>
		</VModal>
	);
}

export default CopyVoucherDialog;
